import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MsalProvider } from '@azure/msal-react';
import React from "react"
import Overview from "./pages/Overview";
import Shipping from "./pages/Shipping";
import NotFound from "./pages/Error";
import Login from "./pages/Login";
import LineStatus from "./pages/LineStatus";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";



function App({ instance }) {

  return (
    <MsalProvider instance={instance}>
      <AuthProvider>
        <BrowserRouter basename="/">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/overview" element={
              <ProtectedRoute>
                <Overview />
              </ProtectedRoute>
            } />
            <Route path="/shipping" element={
              <ProtectedRoute>
                <Shipping />
              </ProtectedRoute>
            } />
            <Route path="/linestatus" element={
              <ProtectedRoute>
                <LineStatus />
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
